import { DeletedFile } from '@/assets/illustration'

/**
 * Content Viewer Deleted File State
 *
 * Shown in the document preview pane when the opened reference points at a file that no longer
 * exists. Deletion is permanent, so this deliberately offers no Retry — unlike
 * ContentViewerErrorState, whose retry exists for transient load failures.
 *
 * The illustration is its own asset rather than the shared LoadFilesError one: that glyph has a
 * plain bevelled corner and no fill, where this state's design uses a folded corner over two
 * fills. LoadFilesError still serves the genuine load-failure states elsewhere.
 */
export default function ContentViewerDeletedFileState() {
  return (
    <div role="status" className="flex h-full w-full flex-col items-center justify-center p-4">
      <div className="flex max-w-[292px] flex-col items-center gap-4 pb-6">
        <DeletedFile className="h-10 w-auto shrink-0" aria-hidden />
        <p className="text-center text-sm font-medium leading-5 tracking-[-0.15px] text-brand-neutral-900">This file has been deleted.</p>
      </div>
    </div>
  )
}
